<div class="contacts-wrapper" data-testid="bcr-172-contacts-wrapper">
  <app-toolbar
    [pageTitle]="toolbarTitle() + ' Contacts'"
    backLink="/document-repository"
    backLinkLabel="Back to Document Repository"
    backLinkTestId="bcr-172-back-link"
  />

  <section class="feature-shell">
    <!-- Loading overlay -->
    @if (loading()) {
      <div
        class="loading-overlay"
        data-testid="bcr-172-loading-overlay"
        aria-live="polite"
        aria-label="Loading contacts"
      >
        <app-spinner [display]="true" [diameter]="48" aria-label="Loading" />
      </div>
    }

    <!-- Contact tables (hidden while loading) -->
    @if (!loading()) {
      <!-- IGA Coordinators section -->
      <div class="contacts-section" data-testid="bcr-172-iga-coordinators-section">
        <h2 class="section-title">IGA Coordinators</h2>
        <app-az-table
          data-testid="bcr-172-iga-coordinators-table"
          [data]="igaRows()"
          [columns]="igaColumns"
          [emptyMessage]="'No IGA Coordinators found'"
        />
      </div>
      <!-- Legal Entity Contacts section -->
      <div class="contacts-section" data-testid="bcr-172-legal-entity-contacts-section">
        <h2 class="section-title">Legal Entity Contacts</h2>
        <app-az-table
          data-testid="bcr-172-legal-entity-contacts-table"
          [data]="legalEntityRows()"
          [columns]="legalEntityColumns"
          [emptyMessage]="'No Legal Entity Contacts found'"
        />
      </div>
    }
  </section>

  <app-footer />

  <!-- Error modal -->
  <app-status-change-modal
    data-testid="bcr-172-error-modal"
    [isOpen]="isErrorModalOpen()"
    [initialState]="'error'"
    [title]="'Error'"
    [errorMessage]="errorMessage()"
    (closed)="onErrorModalClose()"
  />
</div>
